import { atom } from "recoil";

// Loading
export const loadingState = atom({
  key: "loadingState",
  default: false,
});